import React, { Component } from 'react';
import { connect } from 'react-redux' ;
import './index.scss';
import Banner from '../about-me/component/banner/banner';
import CardList from './component/card-list';
import { actionCreators } from './store'

class TechService extends Component {
  componentDidMount() {
    this.props.fetchTechData();
  }

  render() {
    const { head } = this.props;
    return (
      <div className="tech-content">
        { head && <Banner  title={head.get('name')} desc={head.get('des')} en={head.get('en')} bannerSrc={head.get('logo')}></Banner> }
        <CardList></CardList>
      </div>
    )
  }
}

const mapState = (state) => ({
  head: state.getIn(['tech', 'head']),
});

const mapDispatch = (dispatch) => ({
  fetchTechData() {
    dispatch(actionCreators.fetchTechData());
  }
});

export default connect(mapState, mapDispatch)(TechService);